import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createDepartmentEntry = createAsyncThunk('createDepartmentEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertDepartment`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateDepartmentEntry = createAsyncThunk('updateDepartmentEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updatedepart`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchDepartmentData = createAsyncThunk('fetchDepartmentData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getdepartlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleDepartment = createAsyncThunk('fetchSingleDepartment', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getdepartlist&departId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleDepartment = createAsyncThunk('deleteSingleDepartment', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteDepart&departId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchEmpDepartWise = createAsyncThunk('fetchEmpDepartWise', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getEmployeeDepartWise&departId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const departmentSlice = createSlice({
    name: 'DepartmentData',
    initialState: {
        isLoading: false,
        department: null,
        deleteDepart: null,
        singleDepart: null,
        deptEmp: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchDepartmentData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchDepartmentData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.department = action.payload;
        });
        builder.addCase(fetchDepartmentData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleDepartment.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleDepartment.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteDepart = action.payload;
        });
        builder.addCase(deleteSingleDepartment.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleDepartment.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleDepartment.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleDepart = action.payload;
        });
        builder.addCase(fetchSingleDepartment.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchEmpDepartWise.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchEmpDepartWise.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deptEmp = action.payload;
        });
        builder.addCase(fetchEmpDepartWise.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

    }
});

export default departmentSlice.reducer;
